import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    messagingChannels: {
      list: []
    }
  },
  mutations: {
    SET_MESSAGING_CHANNELS (store, items) {
      store.messagingChannels.list = items
    }
  },
  getters: {
    getMessagingChannels: (store, getters) => {
      return store.messagingChannels.list
    },
    getMessagingChannel: (store, getters) => (id) => {
      return store.messagingChannels.list.find((channel) => { return channel._id === id }) || null
    }
  },
  actions: {
    /*
    selectMessagingChannels
    loads the account messaging channels and stores them
    */
    selectMessagingChannels ({commit, dispatch, getters, state}, filters) {
      return dispatch('getMessagingChannels', filters)
      .then((response) => {
        commit('SET_MESSAGING_CHANNELS', response)
        return response
      })
    },
    /*
    getMessagingChannels
    */
    getMessagingChannels ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/messaging/channels`, {params: filters})
      .then((response) => {
        return response.data || []
      })
    },
    /*
    getMessagingChannelTemplates
    approved whatsapp templates available for a channel
    */
    getMessagingChannelTemplates ({commit, dispatch, getters, state}, {id, filters}) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/messaging/channels/${id}/whatsapp-templates`, {params: filters})
      .then((response) => {
        return response.data || {}
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/messagingChannels.js